module.exports = __webpack_public_path__ + "img/collectiongallery_signet@2x.5b2975e.webp";